import { create } from 'zustand';

import { SECURE_API } from 'src/api/api';
import { runApiAction } from 'src/stores/lib/runApiAction';

interface TransfersState {
  isLoading: boolean;
  error: unknown | null;
  initParticipantTransfer: (
    participantId: string,
    toUserEmail: string,
    dateOfBirth?: Date | null,
  ) => Promise<{ id: string } | undefined>;
  acceptTransfer: (token: string) => Promise<{ accepted: boolean } | undefined>;
  rejectTransfer: (token: string) => Promise<{ rejected: boolean } | undefined>;
}

const useTransfersStore = create<TransfersState>(set => ({
  isLoading: false,
  error: null,

  initParticipantTransfer: async (participantId, toUserEmail, _dateOfBirth) =>
    runApiAction({
      set,
      setLoading: true,
      clearLoadingOnFinish: true,
      onError: error => set({ error }),
      action: async () => {
        const { data } = await SECURE_API.post<{ id: string }>(
          `/me/participants/${participantId}/transfer/init`,
          { toUserEmail },
        );
        return data;
      },
    }),

  acceptTransfer: async token =>
    runApiAction({
      set,
      setLoading: true,
      clearLoadingOnFinish: true,
      onError: error => set({ error }),
      action: async () => {
        const { data } = await SECURE_API.post<{ accepted: boolean }>(`/me/transfers/accept`, {
          token,
        });
        return data;
      },
    }),

  rejectTransfer: async token =>
    runApiAction({
      set,
      setLoading: true,
      clearLoadingOnFinish: true,
      onError: error => set({ error }),
      action: async () => {
        const { data } = await SECURE_API.post<{ rejected: boolean }>(`/me/transfers/reject`, {
          token,
        });
        return data;
      },
    }),
}));

export default useTransfersStore;
